import * as React from 'react';
import Button from '@mui/material/Button';

export default function Navigation() {
    return (
        <div className="Nav-bar-wrapper">
            <Button variant="contained" href="#"
                    sx={{
                        backgroundColor: '#E0E0E0',  // Background color
                        color: '#1A1A1A',           // Text color
                        '&:hover': {
                            backgroundColor: '#9E9E9E',  // Hover background color
                        },
                    }}>
                Home
            </Button>
            <Button variant="contained" href="#"
                    sx={{
                        backgroundColor: '#E0E0E0',  // Background color
                        color: '#1A1A1A',           // Text color
                        '&:hover': {
                            backgroundColor: '#9E9E9E',  // Hover background color
                        },
                    }}>
                About Me
            </Button>
            <Button variant="contained" href="#"
                    sx={{
                        backgroundColor: '#E0E0E0',  // Background color
                        color: '#1A1A1A',           // Text color
                        '&:hover': {
                            backgroundColor: '#9E9E9E',  // Hover background color
                        },
                    }}>
                Projects
            </Button>
            <Button variant="contained" href="#"
                    sx={{
                        backgroundColor: '#E0E0E0',  // Background color
                        color: '#1A1A1A',           // Text color
                        '&:hover': {
                            backgroundColor: '#9E9E9E',  // Hover background color
                        },
                    }}>
                Contact
            </Button>
            <Button variant="contained" href="#"
                    sx={{
                        backgroundColor: '#E0E0E0',  // Background color
                        color: '#1A1A1A',           // Text color
                        '&:hover': {
                            backgroundColor: '#9E9E9E',  // Hover background color
                        },
                    }}>
                GitHub
            </Button>
        </div>
    );
}